import { render, staticRenderFns } from "./jiayanxiu.vue?vue&type=template&id=2421e27b&scoped=true"
import script from "./jiayanxiu.vue?vue&type=script&lang=js"
export * from "./jiayanxiu.vue?vue&type=script&lang=js"
import style0 from "./jiayanxiu.vue?vue&type=style&index=0&id=2421e27b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2421e27b",
  null
  
)

export default component.exports